import React from 'react';
import {View, ViewProperties} from '@lookiero/aurora';
import {style} from './InfoContainer.styles';

export const InfoContainer: React.FC<{style?: ViewProperties['style']; children: React.ReactNode}> = ({
  style: customStyle,
  children,
}) => <View style={[style.container, customStyle]}>{children}</View>;
